/* Harding & Bloom consent-aware Google Ads attribution persistence. */
(function () {
  "use strict";

  var STORAGE_KEY = "hb_google_attribution_v1";
  var SYNC_KEY = "hb_google_attribution_synced_v1";
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var PARAMS = ["gclid", "gbraid", "wbraid", "gad_campaignid", "gad_source", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  var ID_PARAMS = ["gclid", "gbraid", "wbraid", "gad_campaignid"];
  var PAID_MEDIA = ["cpc", "ppc", "paid", "paid_search", "paid-search", "pmax", "shopping", "display"];

  function privacyAllowsMarketing() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;
    try { return privacy.marketingAllowed() === true; } catch (_) { return false; }
  }

  function storageRemove() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
      window.sessionStorage.removeItem(SYNC_KEY);
    } catch (_) {}
  }

  function clean(value) {
    return String(value || "").trim().slice(0, 500);
  }

  function capturePaidGoogleTouch() {
    var query = new URLSearchParams(window.location.search || "");
    var values = {};
    PARAMS.forEach(function (name) {
      var value = clean(query.get(name));
      if (value) values[name] = value;
    });
    var source = String(values.utm_source || "").toLowerCase();
    var medium = String(values.utm_medium || "").toLowerCase();
    var hasIdentifier = ID_PARAMS.some(function (name) { return Boolean(values[name]); });
    var hasPaidGoogleUtm = (source === "google" || source === "adwords") && PAID_MEDIA.indexOf(medium) !== -1;
    if (!hasIdentifier && !hasPaidGoogleUtm) return null;
    return { capturedAt: Date.now(), values: values };
  }

  function readStoredTouch() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "null");
      if (!parsed || !parsed.capturedAt || !parsed.values || Date.now() - parsed.capturedAt > MAX_AGE_MS) {
        storageRemove();
        return null;
      }
      return parsed;
    } catch (_) {
      storageRemove();
      return null;
    }
  }

  function storeTouch(touch) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(touch)); } catch (_) {}
  }

  function attributesFor(touch, clear) {
    var attributes = {};
    PARAMS.forEach(function (name) {
      var value = clear ? "" : clean(touch && touch.values && touch.values[name]);
      if (clear || value) attributes["__hb_gads_" + name] = value;
    });
    attributes.__hb_gads_captured_at = clear ? "" : new Date(touch.capturedAt).toISOString();
    return attributes;
  }

  function cartUpdate(attributes, syncValue) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    return window.fetch(root + "cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart attribution update failed");
      try { window.sessionStorage.setItem(SYNC_KEY, syncValue); } catch (_) {}
    }).catch(function () {});
  }

  function clearTracking() {
    var hadTracking = false;
    try { hadTracking = Boolean(window.localStorage.getItem(STORAGE_KEY) || window.sessionStorage.getItem(SYNC_KEY)); } catch (_) {}
    storageRemove();
    if (hadTracking) cartUpdate(attributesFor(null, true), "");
  }

  function run() {
    if (!privacyAllowsMarketing()) {
      clearTracking();
      return;
    }
    var current = capturePaidGoogleTouch();
    if (current) storeTouch(current);
    var touch = current || readStoredTouch();
    if (!touch) return;
    var attributes = attributesFor(touch, false);
    var syncValue = JSON.stringify(attributes);
    try { if (window.sessionStorage.getItem(SYNC_KEY) === syncValue) return; } catch (_) {}
    cartUpdate(attributes, syncValue);
  }

  document.addEventListener("visitorConsentCollected", run);
  run();
})();
